import React, { useState, useEffect, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { Table } from 'antd';
import { filterColumns } from '../../../constants/Stats';
import ResizeableTitle from '../../../components/DataTable/ResizeableTitle';

function handleResize(index: number, columns: any[], setTableColumns: (cols: any[]) => void) {
  return (_: any, { size }: any) => {
    const nextColumns = [...columns];
    nextColumns[index] = {
      ...nextColumns[index],
      width: size.width,
    };
    setTableColumns(nextColumns);
  };
}

function StatsTable(props: any) {
  const [tableColumns, setTableColumns] = useState<any[]>([]);
  const advertiserId = useSelector((state: any) => state.auth.aid);

  useEffect(() => {
    let filteredColumns = filterColumns(props.columns);
    filteredColumns = filterColumns(props.columns);
    const columns = filteredColumns.map((column, index) => ({
      width: 100,
      ...column,
      sorter: false,
      align: 'center',
      ellipsis: { showTitle: false },
      onHeaderCell: (col: any) => {
        col.ellipsis = false;
        return {
          width: col.width,
          onResize: handleResize(index, columns, setTableColumns),
        };
      },
    }));
    setTableColumns(columns);
  }, [advertiserId, props.columns]);

  const getRowId = useCallback((d: any) => Object.values(d).join('-'), []);

  return (
    <Table
      className="stats-table"
      components={{ header: { cell: ResizeableTitle } }}
      dataSource={props.data}
      columns={tableColumns}
      tableLayout="fixed"
      bordered
      size="small"
      pagination={false}
      rowKey={getRowId}
      loading={props.loading}
      scroll={{
        x: 'max-content',
        scrollToFirstRowOnChange: true,
      }}
    />
  );
}

export default StatsTable;
